import { motion } from "framer-motion";
import { Building2, Store, TrendingUp, User } from "lucide-react";
import { Reveal } from "./Reveal";
import { EASE } from "@/lib/site";

const SCALE = [
  { icon: User, title: "Autônomos", text: "Barbeiros, personal trainers, corretores, contadores e prestadores de serviço." },
  { icon: Store, title: "Pequenos negócios", text: "Restaurantes, lojas, salões de beleza, clínicas e escritórios." },
  { icon: TrendingUp, title: "Empresas em crescimento", text: "Negócios que precisam vender online, organizar e automatizar processos." },
  { icon: Building2, title: "Empresas maiores", text: "Plataformas, sistemas e integrações para operações mais complexas." },
];

export const Impact = () => (
  <section data-testid="impact-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <h2 className="font-display text-3xl font-semibold leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl">
            Seu negócio merece uma presença digital <span className="text-ws-lime">à altura.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5 lg:pt-3">
          <p className="text-base leading-relaxed text-ws-muted md:text-lg">
            Não importa o tamanho do seu negócio ou segmento. A WebStation cria soluções digitais pensadas para suas necessidades.
          </p>
        </Reveal>
      </div>
      <div className="relative mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <div className="pointer-events-none absolute left-0 right-0 top-[52px] hidden h-px bg-gradient-to-r from-transparent via-ws-lime/40 to-transparent lg:block" />
        {SCALE.map((s, i) => (
          <motion.div
            key={s.title}
            data-testid={`impact-card-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
            whileHover={{ y: -6 }}
            className="group relative rounded-3xl border border-white/[0.07] bg-ws-card p-6 transition-[border-color] duration-300 hover:border-ws-lime/40"
          >
            <div className="flex items-center justify-between">
              <span className="relative grid h-14 w-14 place-items-center rounded-2xl border border-ws-lime/25 bg-ws-bg text-ws-lime transition-[box-shadow] duration-300 group-hover:shadow-[0_0_30px_-4px_rgba(124,255,26,.6)]">
                <s.icon size={22} className="transition-transform duration-500 group-hover:scale-110" />
              </span>
              <span className="font-mono text-xs text-ws-muted">0{i + 1}/04</span>
            </div>
            <h3 className="mt-6 text-lg font-medium text-ws-text">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ws-muted">{s.text}</p>
            <div className="mt-6 h-1 overflow-hidden rounded-full bg-white/5">
              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: `${25 * (i + 1)}%` }}
                viewport={{ once: true }}
                transition={{ duration: 1.2, delay: 0.3 + i * 0.12, ease: EASE }}
                className="h-full rounded-full bg-ws-lime"
              />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
